import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom';

import ShipmentOrder from "@pages/ShipmentOrder/index"; // 出库物流信息
import Registration from "@pages/WarehouseManagement/Registration/Registration"; //入库登记
import OutWarehouse from "@pages/WarehouseManagement/OutWarehouse/index";//出库单

import Transfer from "@pages/WarehouseManagement/transfer/index";//调拨

import TakeDelivery from "@pages/WarehouseManagement/takeDelivery/index";//待提货
import Logistics from "@pages/WarehouseManagement/logistics/index";//物流信息管理
import DamageRegistration from "@pages/WarehouseManagement/damageRegistration/list";//破损登记
//仓库管理
class WarehouseRouter extends PureComponent{
    render() {
        return (
            <Switch>

                <Route path="/warehouseManagement/registration" component={Registration} />
                <Route path="/warehouseManagement/damageRegistration" component={DamageRegistration} />


                <Route path="/warehouseManagement/out-delivery" component={OutWarehouse} />

                <Route path="/warehouseManagement/logistics" component={Logistics} />
                <Route path="/warehouseManagement/shipmentOrder" component={ShipmentOrder} />
                <Route path="/warehouseManagement/transfer" component={Transfer} />
                <Route path="/warehouseManagement/takeDelivery" component={TakeDelivery} />
                <Route path="/*" render={(props) => <Redirect to="/warehouseManagement/registration" />} />
            </Switch>
        );
    }
}
export default WarehouseRouter;